export default [
  {
    path: "/error/404",
    name: "NotFound",
    meta: { title: "Not-Found" },
    component: () => import("../views/error/not-found.vue")
  },
  {
    path: "/error/401",
    name: "Deny",
    meta: { title: "Deny" },
    component: () => import("../views/error/deny.vue")
  }
]